import React from 'react'

import CarSettingsHome from 'components/CarSettings/Home'

const CarSettingsPage = () => {
  return <CarSettingsHome />
}

export default CarSettingsPage
